import React, { useContext, useState } from "react";
import { ProcessContext } from "../../../../../contexts/ProcessContext";

import { LOAN_SUMMARY_AND_ADJUST_STEP_NAMES } from "../config";
import GDPROptinsDialog from "../shared/components/GDPROptinsDialog/GDPROptinsDialog";
import useGDPRHandler from "../shared/hooks/useGDPRHandler";
import { useLoanApplication } from "../shared/hooks/useLoanApplication";
import { AddParticipantToLoan } from "./steps/AddParticipantToLoan/AddParticipantToLoan";
import { SummaryAndAdjustWrapper } from "../shared/components/SummaryAndAdjustWrapper/SummaryAndAdjustWrapper";
import { useLoanCalculator } from "../shared/hooks/useLoanCalculator/useLoanCalculator";
import { LoanConditions } from "./components/LoanConditions";
import { useMultiLender } from "../shared/hooks/useMultiLender";
import { RiskAnalysisOptIns } from "./components/RiskAnalysisOptIns";
import { ConfigContext } from "../../../../../contexts/ConfigContext";
import { CustomRegistry } from "@nemuru-eng/js-api-client";
import { Box, Typography } from "@material-ui/core";
import Text from "../../../../shared/components/Text";
import { FullScreenLoading } from "../BorrowerSelectionLoanSummary/_shared/components/FullScreenLoading";

export function LoanSummary({ setLenderSelectionStep }) {
  const {
    state: { participant },
  } = useContext(ProcessContext);

  const {
    state: { registry },
  } = useContext(ConfigContext);

  const { optInsArray, areOptInsSynced, submitOptInsConsents } =
    useGDPRHandler();

  const {
    termMarks,
    minTerm,
    maxTerm,
    loanConditions,
    patchSetLoanCalculator,
    setLoanConditionsByTerm,
    loadingLoanCalculators,
  } = useLoanCalculator();

  const { hasMultiplePricings, allLenders, availableLenders } = useMultiLender({
    loanConditions,
  });

  const {
    handleRequestLoanOrShowOptinsDialog,
    acceptTerms,
    getValues,
    form,
    showOptinsDialog,
    setShowOptinsDialog,
  } = useLoanApplication({
    submitOptInsConsents,
    optInsArray,
    areOptInsSynced,
    patchSetLoanCalculator,
    setLenderSelectionStep,
  });

  const [state, setState] = useState({
    currentModuleStepToShow:
      registry === CustomRegistry.CAIXABANK ||
      registry === CustomRegistry.FACILITEA ||
      registry === CustomRegistry.TESLA
        ? LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.RISK_ANALYSIS_OPT_INS
        : LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.SUMMARY_AND_ADJUST,
  });

  const { currentModuleStepToShow } = state;

  const setModuleStepGroup = (moduleStepGroup) => {
    setState((s) => ({
      ...s,
      currentModuleStepToShow: moduleStepGroup,
    }));
  };

  const handleLoanTermSlider = (_, value) => {
    setLoanConditionsByTerm(value);
  };

  if (loadingLoanCalculators || !allLenders.length) {
    return <FullScreenLoading textId="LOADING_LOAN_CONDITIONS" />;
  }

  return (
    <>
      {showOptinsDialog ? (
        <GDPROptinsDialog
          participant={participant}
          form={form}
          showOptinsDialog={showOptinsDialog}
          acceptTerms={acceptTerms}
          optInsArray={optInsArray}
          areOptInsSynced={areOptInsSynced}
          setShowOptinsDialog={setShowOptinsDialog}
        />
      ) : (
        <>
          {currentModuleStepToShow ===
            LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.RISK_ANALYSIS_OPT_INS && (
            <RiskAnalysisOptIns
              setModuleNextStep={() =>
                setModuleStepGroup(
                  LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.SUMMARY_AND_ADJUST
                )
              }
            />
          )}
          {currentModuleStepToShow ===
            LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.SUMMARY_AND_ADJUST && (
            <SummaryAndAdjustWrapper
              termMarks={termMarks}
              minTerm={minTerm}
              maxTerm={maxTerm}
              getValues={getValues}
              loanConditions={loanConditions}
              setModuleStepGroup={setModuleStepGroup}
              handleLoanTermSlider={handleLoanTermSlider}
              handleRequestLoanOrShowOptinsDialog={
                handleRequestLoanOrShowOptinsDialog
              }
              allLenders={allLenders}
              availableLenders={availableLenders}
              hasMultiplePricings={hasMultiplePricings}
              ConditionsComponent={
                <>
                  <LoanConditions loanConditions={loanConditions} />
                  {hasMultiplePricings && (
                    <Box mt={1}>
                      <Typography variant="caption" color="textSecondary">
                        * <Text tId="CONDITIONS_MULTI_PRICING_MESSAGE" />
                      </Typography>
                    </Box>
                  )}
                </>
              }
            />
          )}
          {currentModuleStepToShow ===
            LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.ADD_CO_BORROWER_TO_LOAN && (
            <AddParticipantToLoan setModuleStepGroup={setModuleStepGroup} />
          )}
        </>
      )}
    </>
  );
}
